module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-4-16dec947ebc47f220524780f3d4618a8.png";